/* eslint-disable multiline-ternary */
import React from "react"
import { Box, Flex, Heading, Img } from "@chakra-ui/react"
import { Colors } from "../../theme/colors"

export interface DistributersInterface {
  isOtherDistributor?: boolean
  title: string
  logo: string
  logoW?: string
  logoH?: string
  website: string
  email?: string
  phone: string | Array<Record<string, string>>
}
interface DistributorCardProps {
  options: DistributersInterface
}
export const DistributorCard: React.FC<DistributorCardProps> = ({ options }): JSX.Element => {
  const { title, logo, website, email, phone, logoH, logoW } = options
  const linkStyles = {
    width: "100%",
    height: "auto",
    justifyContent: "flex-start",
    padding: "0",
    display: "block",
    fontFamily: "PT Sans",
    fontSize: "16px",
    lineHeight: "150%",
    fontWeight: 400,
    color: Colors.Primary.c1
  }

  return (
    <Box w={["204px", "204px", "210px"]} key={title}>
      {title && (
        <Heading fontWeight={"normal"} variant="RHeading3PT" mt={["4px", "4px", "0"]}>
          {title}
        </Heading>
      )}
      <Flex justify={"flex-start"} height="50px" mt="16px">
        <a target="_blank" rel="noreferrer" href={`https://${website}`}>
          <Img src={logo} height={logoH ?? "auto"} width={logoW ?? "auto"} alt={title} style={{ cursor: "pointer" }} />
        </a>
      </Flex>
      <Box mt={["14px", "14px", "16px"]} mb={["4px", "4px", "0"]} lineHeight={["100%", "100%", "150%"]}>
        <a target="_blank" rel="noreferrer" href={`https://${website}`} style={{ ...linkStyles }}>
          {website}
        </a>
        {email && (
          <Box my="2">
            <a target="_blank" rel="noreferrer" href={`mailto:${email}`} style={{ ...linkStyles }}>
              {email}
            </a>
          </Box>
        )}
        <Box>
          {Array.isArray(phone) ? (
            <>
              {phone.map(({ label, value }) => (
                <Flex key={label} alignItems={"center"} {...linkStyles} my={"1"} color="black">
                  {label}
                  {label && ":"}
                  <a target="_blank" rel="noreferrer" href={`tel:${value}`} style={{ ...linkStyles, marginLeft: "4px", display: "inline" }}>
                    {value}
                  </a>
                </Flex>
              ))}
            </>
          ) : (
            <a target="_blank" rel="noreferrer" href={`tel:${phone}`} style={{ ...linkStyles }}>
              {phone}
            </a>
          )}
        </Box>
      </Box>
    </Box>
  )
}
